import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBarSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 w-full bg-accent-gold z-50 shadow-md" data-id="element-204">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-col sm:flex-row items-center justify-center sm:justify-between text-primary font-bold text-sm sm:text-base" data-id="element-205">
        <div className="text-center sm:text-left mb-2 sm:mb-0" data-id="element-206">
          ⚡ OFERTA DE LANZAMIENTO — Termina en: {formatTime(minutes)}:
          {formatTime(seconds)}{' '}
          <span className="hidden sm:inline" data-id="element-207">
            · Solo quedan 30 minutos al precio actual
          </span>
        </div>
        <button onClick={() => {
        const w = window as any;
        if (typeof w.fbq === 'function') {
          w.fbq('track', 'InitiateCheckout', {
            content_name: 'CONTROLA LA ANSIEDAD — Pack Completo Base',
            content_ids: ['ANSIEDAD_BASE_001'],
            value: 19990,
            currency: 'ARS'
          });
        }
        setTimeout(() => {
          window.open('[TU_LINK_MERCADOPAGO_BASE]', '_blank');
        }, 300);
      }} className="bg-primary text-accent-gold px-4 py-1 rounded-full text-xs sm:text-sm hover:bg-opacity-90 transition-colors whitespace-nowrap" data-id="element-208">
          OBTENERLO AHORA →
        </button>
      </div>
    </div>;
}